type PortraitPlaceholderProps = {
  size?: number;
  caption?: string;
};

export function PortraitPlaceholder({ size = 120, caption = "portrait" }: PortraitPlaceholderProps) {
  return (
    <div
      style={{
        width: size,
        height: size,
        position: "relative",
        boxShadow: "inset 0 0 0 0.5px var(--hairline-strong)",
        background: `linear-gradient(160deg,
          color-mix(in oklab, var(--accent) 16%, var(--bg)) 0%,
          color-mix(in oklab, var(--text) 22%, var(--bg)) 100%)`,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage:
            "repeating-linear-gradient(135deg, rgba(28,26,23,0.025) 0 1px, transparent 1px 4px)",
        }}
      />
      <div
        style={{
          position: "absolute",
          left: 8,
          bottom: 6,
          fontFamily: "var(--mono)",
          fontSize: 9,
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          color: "rgba(244,239,230,0.75)",
        }}
      >
        {caption}
      </div>
    </div>
  );
}
